// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `template-container {
	display: none;
}
.template-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	margin: 0rem;
	width: 100%;
}
.template-content .overlay {
	position: absolute;
	/* width: 100vw; */
	right: 0;
	top: 40px;
	z-index: 5;
}
.template-content.overlay {
	display: none;
}
.template-content .overlay img {
	width: 30vw;
	height: 30vw;
	clip-path: circle(250px at 50% 50%);
	animation: rotate-layover 120s infinite linear;
}
.bottom-container .spacer {
	min-height: 10rem;
	height: 20rem;
	margin: 0rem;
	padding: 0rem;
	display: none;
}
p.condense {
	line-height: 1.5rem;
}
.mobile-noninteractive {
	display: contents;
}
.image-cover img {
	max-width: 400px;
	height: 100%;
	object-fit: contain;
	padding: 1rem;
}

@media (min-width: 500px) {
	.template-content {
		position: relative;
		/* display: none;  */
	}
	.mobile-noninteractive {
		display: none;
	}
	.template-content .overlay {
		position: absolute;
		display: unset;
		right: 0rem;
		width: unset;
		top: 5rem;
		/* z-index: 1; */
	}

	.template-content.bottom-container {
		width: 100%;
		padding-right: 1rem;
		padding-left: 1rem;
	}

	.template-container {
		z-index: -1;

		display: contents;
		height: 100%;
		overflow-x: hidden;
	}
}

@media (min-width: 1000px) {
	.mobile-noninteractive {
		display: none;
	}

	.template-content .overlay img {
		width: 30vw;
		height: 30vw;
		max-width: 300px;
		max-height: 300px;
		clip-path: circle(250px at 50% 50%);
		animation: rotate-layover 120s infinite linear;
		/* This animation causes the overlay pic to go out ouf bounds 
      which inturn increases page width. I think a  */
	}
}

@media (min-width: 1500px) {
	.bottom-container {
		width: 100%;
		max-width: calc(1223px + 2vw);
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/TemplatePage/TemplatePage.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,8BAA8B;CAC9B,YAAY;CACZ,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;AACX;AACA;CACC,aAAa;AACd;AACA;CACC,WAAW;CACX,YAAY;CACZ,mCAAmC;CACnC,8CAA8C;AAC/C;AACA;CACC,iBAAiB;CACjB,aAAa;CACb,YAAY;CACZ,aAAa;CACb,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC;EACC,kBAAkB;EAClB,oBAAoB;CACrB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;CACnB;;CAEA;EACC,WAAW;;EAEX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,8CAA8C;EAC9C;qDACmD;CACpD;AACD;;AAEA;CACC;EACC,WAAW;EACX,6BAA6B;CAC9B;AACD","sourcesContent":["template-container {\n\tdisplay: none;\n}\n.template-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin: 0rem;\n\twidth: 100%;\n}\n.template-content .overlay {\n\tposition: absolute;\n\t/* width: 100vw; */\n\tright: 0;\n\ttop: 40px;\n\tz-index: 5;\n}\n.template-content.overlay {\n\tdisplay: none;\n}\n.template-content .overlay img {\n\twidth: 30vw;\n\theight: 30vw;\n\tclip-path: circle(250px at 50% 50%);\n\tanimation: rotate-layover 120s infinite linear;\n}\n.bottom-container .spacer {\n\tmin-height: 10rem;\n\theight: 20rem;\n\tmargin: 0rem;\n\tpadding: 0rem;\n\tdisplay: none;\n}\np.condense {\n\tline-height: 1.5rem;\n}\n.mobile-noninteractive {\n\tdisplay: contents;\n}\n.image-cover img {\n\tmax-width: 400px;\n\theight: 100%;\n\tobject-fit: contain;\n\tpadding: 1rem;\n}\n\n@media (min-width: 500px) {\n\t.template-content {\n\t\tposition: relative;\n\t\t/* display: none;  */\n\t}\n\t.mobile-noninteractive {\n\t\tdisplay: none;\n\t}\n\t.template-content .overlay {\n\t\tposition: absolute;\n\t\tdisplay: unset;\n\t\tright: 0rem;\n\t\twidth: unset;\n\t\ttop: 5rem;\n\t\t/* z-index: 1; */\n\t}\n\n\t.template-content.bottom-container {\n\t\twidth: 100%;\n\t\tpadding-right: 1rem;\n\t\tpadding-left: 1rem;\n\t}\n\n\t.template-container {\n\t\tz-index: -1;\n\n\t\tdisplay: contents;\n\t\theight: 100%;\n\t\toverflow-x: hidden;\n\t}\n}\n\n@media (min-width: 1000px) {\n\t.mobile-noninteractive {\n\t\tdisplay: none;\n\t}\n\n\t.template-content .overlay img {\n\t\twidth: 30vw;\n\t\theight: 30vw;\n\t\tmax-width: 300px;\n\t\tmax-height: 300px;\n\t\tclip-path: circle(250px at 50% 50%);\n\t\tanimation: rotate-layover 120s infinite linear;\n\t\t/* This animation causes the overlay pic to go out ouf bounds \n      which inturn increases page width. I think a  */\n\t}\n}\n\n@media (min-width: 1500px) {\n\t.bottom-container {\n\t\twidth: 100%;\n\t\tmax-width: calc(1223px + 2vw);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
